import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import {
    hba1cSchema,
    hdlCholesterolSchema,
    ldlCholesterolSchema,
    triglyceridenSchema,
} from '@common/validation/schemas';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import type { BariPostEnrollmentDataV2 } from './bariPostEnrollmentDataV2';
import { bariPostEnrollmentDraftV1, bariPostEnrollmentFinalV1 } from '../v1/bariPostEnrollmentSchemaV1';

const bariPostEnrollmentFinalSchemaFieldsV2 = {
    HDL_cholesterol: hdlCholesterolSchema,
    LDL_cholesterol: ldlCholesterolSchema,
    hba1c: hba1cSchema,
    triglyceriden: triglyceridenSchema,
};

const bariPostEnrollmentFinalV2: TypedSchema<BariPostEnrollmentDataV2> = {
    ...bariPostEnrollmentFinalV1,
    ...bariPostEnrollmentFinalSchemaFieldsV2,
};

const bariPostEnrollmentDraftV2 = {
    ...bariPostEnrollmentDraftV1,
    ...addAllowNull(bariPostEnrollmentFinalSchemaFieldsV2),
};

export const bariPostEnrollmentDraftSchemaV2 = Koi.object(bariPostEnrollmentDraftV2);
export const bariPostEnrollmentFinalSchemaV2 = Koi.object(bariPostEnrollmentFinalV2);
